import React, { useState } from 'react';
import { SectionTitle } from '../ui/CommonComponents';
import { ProjectCard } from '../ui/ProjectCard';
import { ProjectModal } from '../modals/ProjectModal';
import RevealOnScroll from '../../hooks/useRevealOnScroll';
import { projects } from '../../data/portfolioData';
import { useTranslation } from '../../hooks/useTranslation';

export const ProjectsSection = () => {
    const { t } = useTranslation();
    const [selectedProject, setSelectedProject] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleProjectClick = (project) => {
        setSelectedProject(project);
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setSelectedProject(null);
    };

    return (
        <section id="projects" className="py-20 px-6 bg-[#0d0d0d]">
            <div className="container mx-auto">
                <RevealOnScroll>
                    <SectionTitle title={t('projectsTitle')} subtitle={t('projectsSubtitle')} />
                </RevealOnScroll>

                <div className="grid md:grid-cols-3 gap-8 auto-rows-fr">
                    {projects.map((project, index) => (
                        <RevealOnScroll key={index} delay={index * 150}>
                            <ProjectCard
                                {...project}
                                onClick={() => handleProjectClick(project)}
                            />
                        </RevealOnScroll>
                    ))}
                </div>
            </div>

            {selectedProject && (
                <ProjectModal
                    project={selectedProject}
                    isOpen={isModalOpen}
                    onClose={handleCloseModal}
                />
            )}
        </section>
    );
};